import * as THREE from 'three';
import { createPlane, positionPlanesInCircle } from '../helpers/worldHelpers';
import { material1, material2, material3 } from '../helpers/texturesAndGeometries';
import { generateGradient } from '../helpers/colors';
import gsap from 'gsap/gsap-core';
/**
 * @class CircularPlanes
 * @description Creates a circular plane
 * @param {number} radius
 * @param {number} width
 *  
 * @param {number} height
 * @param {number} numSegments
 * @param {THREE.Object3D} container
 * @param {number} imaginary items in circle (max)
 * @returns {CircularPlanes}
 * @example
 * const circularPlanes = new CircularPlanes(10, 10, 10, 10, container);
 * */

class CircularPlanes {
  constructor(radius, width, height, numSegments, container, max, offsetAngle) {
    // Create a noise  const color1 = '#FF5733';
    // const color2 = '#33FF57';
    const gradient = generateGradient("#6b9d10", "#B5CE88", numSegments);
    this.planes = [];
    for (let i = 0; i < numSegments; i++) {
      const m = new THREE.MeshBasicMaterial({
        color: gradient[i],
        // wireframe: true,
        side: THREE.DoubleSide,
        transparent: true, // Set to true if you want to adjust opacity
        opacity: 1 // Set your desired opacity (0 = fully transparent, 1 = fully opaque)
      });
      const plane = createPlane(width, height, m);
      this.planes.push(plane);
      container.add(plane)
      plane.translateZ(-7);
      plane.renderOrder = -7;
    }
    // positionPlanesInCircle(this.planes, radius, max);
    positionPlanesInCircle(this.planes, radius, max, offsetAngle);
  }

  // Method to update the mesh with noise
  update(t) {
    for (let i = 0; i < this.planes.length; i++) {
    }
  }

  // Method to get the mesh
  getMesh() {
    return this.mesh;
  }
  startAnimation() {
    this.planes.forEach((mesh, index) => {
      gsap.killTweensOf(mesh.scale);
      mesh.scale.x = 5;
      gsap.to(mesh.scale, {
        duration: .5,
        x: 1, // Target scale in x direction
        delay: 1.5 + (index * 0.025) // Staggered delay for each mesh
      });
    });
  }
  setMood(id) {
    switch (Number(id)) {
      case 1:
        this.planes.map(item => item.material = material1);
        break;
      case 2:
        this.planes.map(item => item.material = material2);
        break;
      case 3:
        this.planes.map(item => item.material = material3);
        break;
    }
  }
}

export default CircularPlanes;
